import { AxiosInstance } from "axios";
import { logger } from "../../../utils/logger";

/**
 * Interceptor de tratamento de erros centralizado
 * 
 * Funcionalidades:
 * - Log de erros detalhado
 * - Tratamento específico por tipo de erro
 * - Retry automático para erros de rede
 * - Notificação de erros para o usuário
 */
export const setupErrorInterceptor = (client: AxiosInstance): void => {
  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Log detalhado do erro
      logger.error("[Error Interceptor] API Error:", {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
      });

      // Tratamento específico por tipo de erro
      if (error.response) {
        // Erro de resposta do servidor
        switch (error.response.status) {
          case 400:
            logger.warn("[Error Interceptor] Bad Request:", error.response.data);
            break;
          case 403:
            logger.warn("[Error Interceptor] Forbidden:", error.response.data);
            break;
          case 404:
            logger.warn("[Error Interceptor] Not Found:", error.config?.url);
            break;
          case 500:
            logger.error("[Error Interceptor] Server Error:", error.response.data);
            break;
          default:
            logger.error("[Error Interceptor] Unexpected Error:", error.response.data);
        }
      } else if (error.request) {
        // Erro de rede (sem resposta)
        logger.error("[Error Interceptor] Network Error:", error.message);
      } else {
        // Erro de configuração
        logger.error("[Error Interceptor] Config Error:", error.message);
      }

      return Promise.reject(error);
    }
  );
}; 